import { Component, Inject } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatIconModule } from "@angular/material/icon";
import {
  MAT_SNACK_BAR_DATA,
  MatSnackBarRef,
} from "@angular/material/snack-bar";

@Component({
  selector: "evta-toast-snackbar",
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div class="evta-toast">
      <mat-icon class="evta-toast__icon">{{ data.icon }}</mat-icon>
      <span class="evta-toast__message">{{ data.message }}</span>
      <button class="evta-toast__close" (click)="dismiss()">Close</button>
    </div>
  `,
  styles: [
    `
      .evta-toast {
        display: flex;
        align-items: center;
        gap: 10px;
        color: white;
        font-size: 15px;
      }

      .evta-toast__icon {
        font-size: 22px;
        width: 22px;
        height: 22px;
      }

      .evta-toast__message {
        flex: 1;
      }

      .evta-toast__close {
        background: none;
        border: none;
        color: white;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        padding: 0 4px;
        opacity: 0.9;
      }

      .evta-toast__close:hover {
        opacity: 1;
      }
    `,
  ],
})
export class ToastSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: { message: string; icon: string },
    private snackBarRef: MatSnackBarRef<ToastSnackbarComponent>
  ) {}

  dismiss(): void {
    this.snackBarRef.dismiss();
  }
}
